module.exports = __webpack_public_path__ + "img/sigap-logo-branco.60cce825.png";